const getTodayDefault = () => {
  return new Date().toDateString();
}

const getTodayCondensed = () => {
  return new Date().toLocaleDateString();
}

const getTodayExpanded = () => {
  let d = new Date();
  let options = {
    weekday: 'long',
    month: 'long',
    day: 'numeric',
    year: 'numeric',
  };
  return d.toLocaleDateString(undefined, options);
}

const getTimeNow = () => {
  let d = new Date();
  let options = {
    hour12: true,
    hour: '2-digit',
    minute: '2-digit',
    timeZoneName: "short"
  };
  return d.toLocaleTimeString(undefined, options);
}

const getTimeAt = (t) => {
  let d = new Date(t);
  let options = {
    hour12: true,
    hour: '2-digit',
    minute: '2-digit',
    timeZoneName: "short"
  };
  return d.toLocaleTimeString(undefined, options);
}

const getRawTimestampNow = () => {
  return Date.now();
}

const getRawDateTimeNow = () => {
  return new Date().toString();
}

const getTodayCustom = (t=undefined) => {
  let d = t ? new Date(t) : new Date();
  let options = {
    weekday: 'long',
    month: 'short',
    day: 'numeric',
    year: 'numeric'
  }
  let out = d.toLocaleString(undefined, options);
  return out;
}

module.exports = {
  getTodayDefault,
  getTodayCondensed,
  getTodayExpanded,
  getTimeNow,
  getTimeAt,
  getRawTimestampNow,
  getRawDateTimeNow,
  getTodayCustom
}
